import './App.css';
import PrintTestPage from './components/PrintTestPage';

function App() {
  return (
    <div className="App">
      <PrintTestPage />
    </div>
  );
}

export default App;
